<template>
    <div class="verify-email"></div>
</template>

<script>
export default {
    created() {
        console.log(this.$route.query.token);
        this.$store.dispatch('user/verifyEmail', this.$route.query.token);
    }
}
</script>

<style scoped lang="scss">
.verify-email{
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
